import {
    APP_ROUTE_KEYS,
    ROUTE_BASE_PATHNAMES,
} from "repoV2/constants/urls&routing/routing";
import { COMMUNITY_URL_QUERY_PARAMS } from "repoV2/pages/brandedCommunity/constants/brandedCommunity.constants";
import { URL_SEARCH_PARAMS } from "repoV2/constants/urls&routing/urlParams";
import { appendURLSearchParams } from "./urlParams";

/**
 * @description use this function to get pathnames for navigating using router(or history) push, replace ..etc
 */
export const constructRoute = ({
    appRouteKey,
    args = {},
}: {
    appRouteKey: string;
    args?: Record<string | number | symbol, string | number>;
}) => {
    switch (appRouteKey) {
        case APP_ROUTE_KEYS.PLAN:
            return `${ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.PLAN]}/${
                args.planSlug
            }`;
        case APP_ROUTE_KEYS.MY_CLASSES:
            return `${ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.MY_CLASSES]}`;
        case APP_ROUTE_KEYS.SALE:
            return `${ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.SALE]}/${args.slug}`;
        case APP_ROUTE_KEYS.CHECKOUT_LISTING:
            return `${ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.CHECKOUT_LISTING]}/${
                args.slug
            }`;
        case APP_ROUTE_KEYS.BRANDED_COMMUNITY:
            return appendURLSearchParams(
                `${ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.BRANDED_COMMUNITY]}/${
                    args.slug
                }`,
                {
                    [COMMUNITY_URL_QUERY_PARAMS.section]: args.section,
                    [COMMUNITY_URL_QUERY_PARAMS.channel]: args.channel,
                    [COMMUNITY_URL_QUERY_PARAMS.custom_link_uuid]:
                        args.customLink,
                }
            );
        case APP_ROUTE_KEYS.EVENT:
            return `/${args.slug}`;
        case APP_ROUTE_KEYS.LOGIN:
            return `${ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.LOGIN]}?${[
                URL_SEARCH_PARAMS.NEXT,
            ]}=${args.next}`;
        case APP_ROUTE_KEYS.LEADERBOARD:
            return `${ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.LEADERBOARD]}/${
                args.listingUuid
            }`;
        case APP_ROUTE_KEYS.CONTENT:
            return `${ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.CONTENT]}?${
                URL_SEARCH_PARAMS.CONTENT_ID
            }=${args.slug}`;
        case APP_ROUTE_KEYS.THANKYOU_PURCHASE:
            return `/${args.slug}/${
                ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.THANKYOU_PURCHASE]
            }`;
        case APP_ROUTE_KEYS.THANKYOU_OPTIN:
            return `/${args.slug}/${
                ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.THANKYOU_OPTIN]
            }`;
        case APP_ROUTE_KEYS.SUBSCRIPTION_HISTORY:
            return appendURLSearchParams(
                `${ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.SUBSCRIPTION_HISTORY]}/${
                    args.slug
                }`
            );
        case APP_ROUTE_KEYS.PURCHASE_HISTORY:
            return `${ROUTE_BASE_PATHNAMES[APP_ROUTE_KEYS.PURCHASE_HISTORY]}`;
        case APP_ROUTE_KEYS.HOME:
        default:
            return `/`;
    }
};
